module.exports = __webpack_public_path__ + "img/W-S60.83a82b7f.jpg";